import React, {
    useContext,
    useMemo
} from 'react';
import { TranslatorContext, IntlContext } from '@jutro/locale';
import { SgDateUtil } from 'saga-modules';
import SgNumberUtil from 'sg-number-util';
import CommonConstants from 'sg-common-constants';
import messages from './SgPolicySummaryInfo.messages';

function SgPolicySummaryInfo(props) {
    const {
        productInfo,
        policyNumber,
        coverType,
        planType,
        coverLevel,
        periodStartDate,
        periodEndDate,
        paymentPlanName,
        showPaymentMethod,
        totalCost,
        downPayment,
        installment,
        isRenewal,
        nextInstallment,
        remainingInstallments
    } = props;

    const translator = useContext(TranslatorContext);
    const intl = useContext(IntlContext);
    const isAnnual = useMemo(() => {
        return paymentPlanName === CommonConstants.PAYMENT_PLANS.ANNUAL
            || paymentPlanName === CommonConstants.PAYMENT_PLANS.ANNUAL_UPFRONT;
    }, [paymentPlanName]);

    return (
        <>
            <div className="sgConfirmationPolicySummaryDetails">
                <div id="productInfoValue" className="sg-flex-div">
                    <h3>
                        {productInfo}
                    </h3>
                </div>
                <ul className="sg-policyInfoDetailsList">
                    <li>
                        <div className="sg-flex-div">
                            <span>{translator(messages.PolicyNumberLabel)}</span>
                            <span id="policyNumberValue">{policyNumber}</span>
                        </div>
                    </li>
                    {coverType && (
                        <li>
                            <div className="sg-flex-div">
                                <span>{translator(messages.CoverTypeLabel)}</span>
                                <span id="coverTypeValue">{coverType}</span>
                            </div>
                        </li>
                    )}
                    <li>
                        <div className="sg-flex-div">
                            <span>{planType ? translator(messages.PlanTypeLabel) : translator(messages.CoverLevelLabel)}</span>
                            <span id="coverLevelValue">{coverLevel}</span>
                        </div>
                    </li>
                    <li>
                        <div className="sg-flex-div">
                            <span>{translator(messages.PolicyYearLabel)}</span>
                            <span id="policyYearValue">
                                {translator(messages.PolicyYearInfo, {
                                    startDate: SgDateUtil.getDateWithFullMonthName(periodStartDate),
                                    endDate: SgDateUtil.getDateWithFullMonthName(periodEndDate)
                                })}
                            </span>
                        </div>
                    </li>
                    {showPaymentMethod && (
                        <li>
                            <div className="sg-flex-div">
                                <span>{translator(messages.PaymentMethodLabel)}</span>
                                <span id="paymentMethodValue">
                                    {isAnnual ? translator(messages.Annual) : translator(messages.DirectDebit)}
                                </span>
                            </div>
                        </li>
                    )}
                </ul>
                <div className="sg-flex-div">
                    {isAnnual && (
                        <h3>
                            <span>{translator(messages.AmountPaidLabel)}</span>
                            <span id="amountPaidValue">{SgNumberUtil.getCurrencyValue(intl, totalCost)}</span>
                        </h3>
                    )}
                    {!isAnnual
                        && (isRenewal ? (
                            <ul className="sg-policyInfoDetailsList">
                                <li>
                                    <div className="sg-flex-div sg-paid-today">
                                        <span>{translator(messages.NextInstallmentLabel)}</span>
                                        <span id="amountDownPaymentValue">{SgNumberUtil.getCurrencyValue(intl, nextInstallment)}</span>
                                    </div>
                                </li>
                                <li>
                                    <div className="sg-flex-div">
                                        <span>{translator(messages.RemainingInstallmentsLabel)}</span>
                                        <span id="amountInstallmentValue">{SgNumberUtil.getCurrencyValue(intl, remainingInstallments)}</span>
                                    </div>
                                </li>
                                <li>
                                    <div className="sg-flex-div">
                                        <span>{translator(messages.TotalCostLabel)}</span>
                                        <span id="amountTotalValue">{SgNumberUtil.getCurrencyValue(intl, totalCost)}</span>
                                    </div>
                                </li>
                            </ul>
                        ) : (
                            <ul className="sg-policyInfoDetailsList">
                                <li>
                                    <div className="sg-flex-div sg-paid-today">
                                        <span>{translator(messages.PaidTodayLabel)}</span>
                                        <span id="amountDownPaymentValue">{SgNumberUtil.getCurrencyValue(intl, downPayment)}</span>
                                    </div>
                                </li>
                                <li>
                                    <div className="sg-flex-div">
                                        <span>{translator(messages.MonthlyPaymentLabel)}</span>
                                        <span id="amountInstallmentValue">{SgNumberUtil.getCurrencyValue(intl, installment)}</span>
                                    </div>
                                </li>
                                <li>
                                    <div className="sg-flex-div">
                                        <span>{translator(messages.TotalCostLabel)}</span>
                                        <span id="amountTotalValue">{SgNumberUtil.getCurrencyValue(intl, totalCost)}</span>
                                    </div>
                                </li>
                            </ul>
                        ))}
                </div>
            </div>
        </>
    );
}

export default SgPolicySummaryInfo;
